// Lightweight dev-only logger. No-ops in production so console output never ships.
export const debugLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};
